import React from 'react';

import Attachment from '../attachment/index';
import Node from '../node/index';
import CarPurchaseModal from '../types/CAR_PURCHASE_LIST/carPurchaseModal/index';
import './index.less';

class Information extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            carPurchaseModalVisible: false,
            carPurchaseModalData: [],
        };
    }
    componentWillReceiveProps(prevProps){
        this.setState({
            data: prevProps.data
        });
    }

    templateFn (obj, j){
        /**
         * TEXT {文本类型}
         * FILE {文件类型}
         * HTML {富文本}
         * NODE {审批节点}
         * CAR_PURCHASE_LIST {购车清单} 定制化
         */
        let template = {
            TEXT: (
                <li className={"blockText " + (obj.className ? obj.className : '')} key={'block_' + j}>
                    <div className="blockName">{obj.name}</div>
                    <div className="blockValue">{obj.value}</div>
                </li>
                ),
            FILE: (
                <li className="blockFile" key={'block_' + j}>
                    <div className="blockName">{obj.name}</div>
                    <Attachment fileData={obj.value || []} />
                </li>
                ),
            HTML: (
                <li className="blockFile" key={'block_' + j}>
                    <div className="blockName">{obj.name}</div>
                    {
                        obj.value ? (<div className="blockValue" dangerouslySetInnerHTML={{__html: obj.value}}></div>) : (<div className="blockValue">-</div>)
                    }
                </li>
                ),
            NODE: (
                <li className="blockNode" key={'block_' + j}>
                    <Node data={obj.value} />
                </li>
                ),
            CAR_PURCHASE_LIST: (
                <li className="blockText" key={'block_' + j}>
                    <div className="blockName">{obj.name}</div>
                    <div className="blockValue clickViewText" onClick={() => this.openCarPurchaseModal(obj.value)}>点击查看</div>
                </li>
                ),
        }
        if(obj.hideType){
            return;
        }
        // console.log(obj)
        return template[obj.type];
    }

    blocksHtml(blocks) {
        // console.log(blocks)
        if(Array.isArray(blocks)){
            if(blocks.length > 0){
                return blocks.map((d,x)=>{
                    return this.templateFn(d,x);
                })
            }else {
                return ''
            }
        }else{
            if(blocks){
                const obj = blocks();
                return obj.map((d,x)=>{
                    return this.templateFn(d,x);
                })
            }
        }
    }

    openCarPurchaseModal(data) {
        this.setState({
            carPurchaseModalVisible: true,
            carPurchaseModalData: data || { cars: [] },
        });
    }

    closeCarPurchaseModal() {
        this.setState({
            carPurchaseModalVisible: false,
            carPurchaseModalData: { cars: [] },
        });
    }

    childrenHtml(item){
        console.log(item)
        if(item.type === "aggregate"){
            return (
                <div>
                    {item.blocks ? (
                        <ul>
                            {
                                this.blocksHtml(item.blocks)
                            }
                        </ul>
                    ) : ''}
                    <div style={{width:'100%',height:'0px',borderTop:'1px solid #EBEBEB'}}></div>
                    {item.children ? (
                        item.children.map((obj,j)=>{
                            return (
                                <div className="typeChildrenBox" key={'typeChildrenBox_' + j}>
                                    <h2>
                                        {obj.title}
                                    </h2>
                                    <ul>
                                        {
                                            this.blocksHtml(obj.blocks)
                                        }
                                    </ul>
                                </div>
                            )
                        })
                    ) : ''}
                </div>
            )
            
        }else{
            return item.children ? (
                item.children.map((obj,j)=>{
                    return (
                        <div className="typeChildrenBox" key={'typeChildrenBox_' + j}>
                            <h2>
                                {obj.title}
                            </h2>
                            <ul>
                                {
                                    this.blocksHtml(obj.blocks)
                                }
                            </ul>
                        </div>
                    )
                })
            ) : (
                <ul>
                    {
                        this.blocksHtml(item.blocks)
                    }
                </ul>
            )
        }
    }

    render() {
        const {data} = this.state;
        if(!data || !data.informationTypes || data.informationTypes.length === 0){
            return (<div></div>);
        }
        document.getElementsByTagName('title')[0].innerText = `${data.title}详情`;
        let arr = [];
        if(Array.isArray(data.informationTypes)){
            arr = data.informationTypes
        }else{
            arr = data.informationTypes()
        }
        return (
            <div className="InformationBox">
                {
                    arr.map((item, i)=>{
                        return (
                            <div className="typeBox" key={'typeBox_' + i}>
                                <h2>
                                    {item.title}
                                </h2>
                                {this.childrenHtml(item)}
                            </div>
                        )
                    })
                }
                <CarPurchaseModal
                    visible={this.state.carPurchaseModalVisible}
                    onClose={() => this.closeCarPurchaseModal()}
                    data={this.state.carPurchaseModalData}
                />
            </div>
        );
    }
}

export default Information;


// WEBPACK FOOTER //
// ./src/processReview/modules/information/index.js